angular.module('aq.filters.formatters')
.filter('fullDateAdjust', ['UserService', function (UserService) {
    return function (inputDate) {
        return UserService.fullDateAdjust(inputDate);
    }
}]);